<template>
  <router-view :key="$route.fullPath" />
  
  <!-- Floating button to manually clean modal backdrops -->
  <div class="floating-cleaner">
    <!-- <button class="backdrop-cleaner-button" @click="cleanBackdrops" title="Nettoyer les modals">
      <span class="cleaner-icon">×</span>
    </button> -->
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class App extends Vue {
  cleanBackdrops() {
    console.log("Manual backdrop cleanup triggered");
    
    // Remove modal-backdrop elements
    const backdrops = document.getElementsByClassName('modal-backdrop');
    if (backdrops.length > 0) {
      Array.from(backdrops).forEach(backdrop => {
        if (backdrop.parentNode) {
          backdrop.parentNode.removeChild(backdrop);
        }
      });
      
      // Reset body styles
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      
      // Show success message
      alert("Nettoyage des backdrops réussi!");
    } else {
      alert("Aucun backdrop trouvé!");
    }
  }
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  background-color: var(--primary);
}

:root {
  --primary: #234779;
  --secondary: #f1f1f1;
  --silver-mist: #ebebeb;
  --steel-gray: #888888;
  --deep-green: #327f00;
  --rich-red: #ba0c21;
  --oceanic-blue: #0074b5;
  --antique-gold: #cca336;
  --powder-whisper: #d9e6fa;
  --deep-vibrant-green: #347c05;
  --warm-golden-yellow: #e7a730;
  --soft-coral-red: #eb6565;
  --pure-snow: #f2f2f2;
  --graphite: #636363;
  --deep-navy: #1f315a;
  --cornflower-blue: #446ab7;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  background-color: var(--primary);
  min-height: 100vh;
}

/* Floating backdrop cleaner button */
.floating-cleaner {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}

.backdrop-cleaner-button {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: var(--rich-red);
  color: white;
  border: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: opacity 0.3s, transform 0.3s;
}

.backdrop-cleaner-button:hover {
  opacity: 1;
  transform: scale(1.1);
}

.cleaner-icon {
  font-size: 30px;
  line-height: 1;
  margin-top: -3px;
}
</style>
